/* global $ */
import React, { useState, useEffect, useRef } from 'react';
import axiosInstance from "../axiosInstance";
import Swal from "sweetalert2";
import Footer from '../components/Footer';

function Customer() {
    const [customers, setCustomers] = useState([]); // Store customer data
    const [newRecord, setNewRecord] = useState({ name: "", mobileno: "" });
    const [selectedCustomer, setSelectedCustomer] = useState(null); // Selected customer for edit
    const [customerToDelete, setCustomerToDelete] = useState(null);
    const formRef = useRef(null);
    const [isDataTableInitialized, setIsDataTableInitialized] = useState(false);

    useEffect(() => {
        if (customers.length > 0 && window.$) {
            let $ = window.$;

            if (isDataTableInitialized) {
                $(".datatable").DataTable().destroy();
            }

            $(".datatable").DataTable({
                "bFilter": false,
                "autoWidth": false,
                "sDom": "fBtlpi",
                "ordering": true,
                "columnDefs": [{ "targets": "no-sort", "orderable": false }],
                "language": {
                    search: " ",
                    sLengthMenu: "_MENU_",
                    paginate: {
                        next: 'Next <i className="fa fa-angle-double-right ms-2"></i>',
                        previous: '<i className="fa fa-angle-double-left me-2"></i> Previous',
                    },
                },
                initComplete: function () {
                    $(".dataTables_filter").appendTo("#tableSearch");
                    $(".dataTables_filter").appendTo(".search-input");
                },
            });

            setIsDataTableInitialized(true); // Mark DataTable as initialized
        }
    }, [customers]);



    // Fetch Customers
    const fetchCustomers = async () => {
        try {
            const response = await axiosInstance.get("/customer/");
            setCustomers(response.data);
        } catch (error) {
            console.error("Error fetching customers:", error);
        }
    };

    // Fetch Customers from API
    useEffect(() => {
        fetchCustomers();
    }, []);

    // Open Edit Modal and Set Data
    const handleEditClick = (customer) => {
        setSelectedCustomer(customer);
        setNewRecord({ name: customer.name, mobileno: customer.mobileno });
    };


    // Handle Form Input Change
    const handleChange = (e) => {
        setNewRecord({ ...newRecord, [e.target.name]: e.target.value });
    };

    // Handle Update Customer
    const handleUpdate = async (e) => {
        e.preventDefault();
        if (!selectedCustomer) return;

        try {
            await axiosInstance.put(`/customer/${selectedCustomer.id}`, newRecord);
            Swal.fire({
                title: "Updated!",
                text: "Customer updated successfully!",
                icon: "success"
            }).then(() => {
                // Close the modal using jQuery
                $("#edit_customer").modal("hide");
            });
            // Destroy DataTable before updating state
            if ($.fn.DataTable.isDataTable(".datatable")) {
                $(".datatable").DataTable().destroy();
            }

            // Fetch latest data and reinitialize DataTable
            await fetchCustomers();
        } catch (error) {
            console.error("Error updating customer:", error);
            Swal.fire("Error", "Failed to update customer", "error");
        }
    };


    // Handle Delete Customer
    const confirmDelete = async (e, customer) => {
        e.preventDefault();
        if (!customer) return;
        try {
            await axiosInstance.delete(`customer/${customer.id}`);
            setCustomers(customers.filter((customer) => customer.id !== customer.id));
            Swal.fire({
                title: "Deleted!",
                text: "Customer deleted successfully!",
                icon: "success"
            }).then(() => {
                // Close the modal using jQuery
                $("#delete_customer").modal("hide");
            });
            // Destroy DataTable before updating state
            if ($.fn.DataTable.isDataTable(".datatable")) {
                $(".datatable").DataTable().destroy();
            }

            // Fetch latest data and reinitialize DataTable
            await fetchCustomers();
        } catch (error) {
            console.error("Error deleting customer:", error);
            Swal.fire("Error", "Failed to delete customer", "error");
        }
    };

    // Handle Form Submission (Create)
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.classList.add("was-validated");
            return;
        }

        try {
            await axiosInstance.post("/customer", { ...newRecord, created_by: localStorage.getItem("user_id") });
            Swal.fire("Created!", "The Customer record has been created.", "success");
            // Destroy DataTable before fetching new data
            if ($.fn.DataTable.isDataTable(".datatable")) {
                $(".datatable").DataTable().destroy();
            }

            // Fetch latest data and reinitialize DataTable
            await fetchCustomers();

            setNewRecord({ name: "", mobileno: "" });
            formRef.current.classList.remove("was-validated");
        } catch (error) {
            console.error("Error adding customer:", error);
            Swal.fire("Error", "Failed to create customer", "error");
        }
    };


    return (
        <div>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content container-fluid">

                    {/* Page Header */}
                    <div className="page-header">
                        <div className="content-page-header ">
                            <h5>Customer</h5>
                            <div className="list-btn">
                                <ul className="filter-list">
                                    <li>
                                        <a className="btn btn-filters w-auto popup-toggle" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="filter"><span className="me-2"><img src="assets/img/icons/filter-icon.svg" alt="filter" /></span>Filter </a>
                                    </li>
                                    <li className="">
                                        <div className="dropdown dropdown-action" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-original-title="download">
                                            <a href="#" className="btn-filters" data-bs-toggle="dropdown" aria-expanded="false"><span><i className="fe fe-download"></i></span></a>
                                            <div className="dropdown-menu dropdown-menu-right">
                                                <ul className="d-block">
                                                    <li>
                                                        <a className="d-flex align-items-center download-item" href="javascript:void(0);" download><i className="far fa-file-pdf me-2"></i>PDF</a>
                                                    </li>
                                                    <li>
                                                        <a className="d-flex align-items-center download-item" href="javascript:void(0);" download><i className="far fa-file-text me-2"></i>CVS</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <a className="btn-filters" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="print"><span><i className="fe fe-printer"></i></span> </a>
                                    </li>
                                    <li>
                                        <a className="btn btn-primary" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#add_customer"><i className="fa fa-plus-circle me-2" aria-hidden="true"></i>Add New</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* /Page Header */}

                    {/* Table */}
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card-table">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-center table-hover datatable">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th>#</th>
                                                    <th>Customer Name</th>
                                                    <th>Mobile No</th>
                                                    <th>Created On</th>
                                                    <th className="no-sort">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {customers.length > 0 ? (
                                                    customers.map((customer, index) => {
                                                        return (
                                                            <tr key={customer.id}>
                                                                <td>{index + 1}</td>
                                                                <td>{customer.name}</td>
                                                                <td>{customer.mobileno}</td>
                                                                <td>{customer.createdAt ? new Date(customer.createdAt).toLocaleDateString() : "N/A"}</td>
                                                                <td className="d-flex align-items-center">
                                                                    <button
                                                                        className="btn btn-greys bg-success-light me-2"
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#edit_customer"
                                                                        onClick={() => handleEditClick(customer)}
                                                                    >
                                                                        <i className="fa fa-edit me-1"></i>Edit
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-greys bg-danger-light me-2"
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#delete_customer"
                                                                        onClick={(e) => confirmDelete(e, customer)}
                                                                    >
                                                                        <i className="fa fa-trash-alt me-1"></i> Delete
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">
                                                            No customers found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Table */}

                </div>
                <Footer />
            </div>
            {/* /Page Wrapper */}

            {/* Add Customer in Modal */}
            <div className="modal custom-modal fade" id="add_customer" role="dialog">
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header border-0 pb-0">
                            <div className="form-header modal-header-title text-start mb-0">
                                <h4 className="mb-0">Add Customer</h4>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">

                            </button>
                        </div>
                        <form ref={formRef} onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="input-block mb-3">
                                            <label>Name</label>
                                            <input type="text" name="name" value={newRecord.name} onChange={handleChange} className="form-control" placeholder="Customer Name" required />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="input-block mb-3">
                                            <label>Phone Number</label>
                                            <input type="number" name="mobileno" value={newRecord.mobileno} onChange={handleChange} className="form-control" placeholder="Mobile Number" required />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" data-bs-dismiss="modal" className="btn btn-back cancel-btn me-2">Cancel</button>
                                <button type="submit" data-bs-dismiss="modal" className="btn btn-primary paid-continue-btn">Add Customer</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* /Add Customer in Modal */}

            {/* Edit Customer */}
            <div className="modal custom-modal fade" id="edit_customer" role="dialog">
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header border-0 pb-0">
                            <div className="form-header modal-header-title text-start mb-0">
                                <h4 className="mb-0">Edit Customer</h4>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">

                            </button>
                        </div>
                        <form action="#">
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="input-block mb-3">
                                            <label>Customer Name</label>
                                            <input type="text" className="form-control" name="name" value={newRecord.name} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="input-block mb-3">
                                            <label>Mobile Number</label>
                                            <input type="text" className="form-control" name="mobileno" value={newRecord.mobileno} onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" data-bs-dismiss="modal" className="btn btn-back cancel-btn me-2">Cancel</button>
                                <button type="submit" onClick={handleUpdate} className="btn btn-primary paid-continue-btn">Update</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* /Edit Customer */}

            {/* Delete Customer Modal */}
            <div key={customerToDelete?.id} className="modal custom-modal fade" id="delete_customer" role="dialog">
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="form-header">
                                <h3>Delete Customer</h3>
                                <p>Are you sure want to delete?</p>
                            </div>
                            <div className="modal-btn delete-action">
                                <div className="row">
                                    <div className="col-6">
                                        <a href="#" className="btn btn-primary paid-continue-btn" onClick={(e) => { e.preventDefault(); confirmDelete(); }}>Delete</a>
                                    </div>
                                    <div className="col-6">
                                        <a href="#" data-bs-dismiss="modal" className="btn btn-primary paid-cancel-btn">Cancel</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Delete Customer Modal */}

        </div>
    )
}

export default Customer